module.exports = __webpack_public_path__ + "static/media/page-settings.97f02069.png";